
import toastr from 'toastr'
import Swal from 'sweetalert2'



function warningNotification(msg) {
    toastr.warning(msg)
}

function errorNotification(msg) {
    toastr.error(msg)
}

function successNotification(msg) {
    toastr.success(msg)
}


function padNumber(number, size) {
    var s = String(number);
    while (s.length < (size || 2)) {
        s = `0${s}`;
    }
    return s;
}

function date(format = 'd.m.Y', d = null) {
    if(d === null) {
        d = new Date();
    }
    let year = d.getFullYear();
    let month = padNumber(d.getMonth() + 1, 2);
    let day = padNumber(d.getDate(), 2);
    if(format == 'Y-m-d') {
        return `${year}-${month}-${day}`;
    }
    if(format == 'Y-m') { 
        return `${year}-${month}`;
    }
    if(format == 'Y-m-d H:i') { 
        return `${year}-${month}-${day} ${padNumber(d.getHours())}:${padNumber(d.getMinutes())}`;
    }
    if(format == 'd.m.Y H:i') {
        return `${day}.${month}.${year} ${padNumber(d.getHours())}:${padNumber(d.getMinutes())}`;
    }
    if(format == 'd.m.') {
        return `${day}.${month}.`; 
    }
    if(format == 'H:i') {
        return `${padNumber(d.getHours())}:${padNumber(d.getMinutes())}`;
    }
    if(format == 'H:i:s') {
        return `${padNumber(d.getHours())}:${padNumber(d.getMinutes())}:${padNumber(d.getSeconds())}`;
    }
    return `${day}.${month}.${year}`;
}

function formatPrice(value, f = 2) {
    let val = (value/1).toFixed(f).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}


// date

// confirm modal

// format price

// table sort fkt

// ...

// in helper function
let asc = true;
function tableSort() {
    const getCellValue = (tr, idx) => tr.children[idx].getAttribute("data-sort");
    const comparer = (idx, asc) => (a, b) => ((v1, v2) => v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2))(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
    document.querySelectorAll('th').forEach(th => th.addEventListener('click', (() => {
        
        document.querySelectorAll('.th-sort-icon').forEach(function(th_sort_icon) {
            th_sort_icon.style.display = 'none';
        });
        const th_sort_icon = th.children[0];
        if(asc) {
            th_sort_icon.setAttribute('uk-icon', 'chevron-down');
        } else {
            th_sort_icon.setAttribute('uk-icon', 'chevron-up');
        }
        th_sort_icon.style.display = 'inline';

        const table = th.closest('table');
        const tbody = table.querySelector('tbody');
        Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), asc = !asc))
            .forEach(tr => tbody.appendChild(tr) );
    })));
}






async function swalConfirm(title, text, type, confirm_txt) {
    return new Promise((resolve, reject) => {
        Swal.fire({
            title: title,
            text: text,
            icon: type,
            showCancelButton: true,
            confirmButtonColor: type == 'warning' ? '#d33' : '#1fb2a6',
            cancelButtonColor: '#242933',
            confirmButtonText: confirm_txt,
            cancelButtonText: 'Abbrechen'
        }).then((result) => {
            if(result.isConfirmed) {
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });

    
}


function hhmm(minutes) {
    if(!minutes) {
        return '0';
    }
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;

    hours = parseInt(hours);
    mins = parseInt(mins);
  
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMins = String(Math.abs(mins)).padStart(2, '0');
  
    return `${(formattedHours)}:${(formattedMins)}`;
}



function getCurrentPosition() {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
         reject(new Error('Geolocation is not supported by this browser.'));
        }
    });
}
  

async function getLocation() {
    try {
        const position = await getCurrentPosition();
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        return [latitude, longitude];
    } catch (error) {
        return false;
    }
}

getLocation();



export {
    swalConfirm,
    warningNotification,
    errorNotification,
    successNotification,
    tableSort,
    date,
    formatPrice,
    padNumber,
    hhmm,
    getCurrentPosition,
    getLocation,
}